module.exports = __webpack_public_path__ + "img/14.78b2b394.png";